export default {
  // 后裔记录单
  seed: {
    '$schema': 'http://json-schema.org/draft-07/schema#',
    'type': null,
    'title': null,
    // 必填字段
    'required': [
      'to_animal_code',
      'record_date',
    ],
    'properties': {
      'to_animal_code': {
        'view': 'text',
        'type': 'string',
        'title': '动物个体编号',
        'language_key': '',
        'maxLength': 32,
        'order': 1,
        'key': 'to_animal_code'
      },
      'record_date': {
        'view': 'date',
        'type': 'string',
        'title': '日期',
        'language_key': '',
        'maxLength': 0,
        'order': 2,
        'defVal': '#{date}',
        'key': 'record_date'
      },
      'animal_nickName': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '动物昵称',
        'language_key': '',
        'maxLength': 50
      },
    },
    'table': 'ces_main'
  },
  // 设备管理新增
  equipmentSave: {
    '$schema': 'http://json-schema.org/draft-07/schema#',
    'type': 'object',
    'title': null,
    'required': [
      'deviceCommonId',
      'deviceName',
      'companyCode',
      'cylinderCode',
      'venueCode',
      'recordDate'
    ],
    'properties': {
      'companyCode': {
        'view': 'link_down',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '公司',
        // 'defVal': '#{sysOrgCode}',
        'config': {
          'txt': 'depart_name',
          'idField': 'id',
          'condition': 'org_category=\'1\'',
          'linkField': 'aquariumCode',
          'pidField': 'parent_id',
          'table': 'sys_depart',
          'key': 'org_code'
        },
        'language_key': 'efc_ocn_device_management__company_code',
        'others': [
          {
            'title': '海洋馆',
            'field': 'aquariumCode'
          },
          {
            'title': '展区',
            'field': 'venueCode'
          },
          {
            'title': '缸体',
            'view': 'list_multi',
            'field': 'cylinderCode'
          }
        ]
      },
      'recordDate': {
        'view': 'date',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '业务日期',
        'defVal': '#{date}',
        'language_key': 'efc_ocn_device_change_record__record_date',
        'maxLength': 0,
        'order': 10
      },
      'deviceCommonId': {
        'view': 'sel_search',
        'dictCode': 'id',
        'dictTable': 'efc_ocn_device_common_name',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备类型',
        'language_key': 'efc_ocn_device_management__device_common_id',
        'dictText': 'name'
        // 'order': 2
      },
      'deviceCode': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备编号',
        'language_key': 'efc_ocn_device_management__device_code',
        'maxLength': 50
        // 'order': 3
      },
      'deviceName': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备名称',
        'language_key': 'efc_ocn_device_management__device_name',
        'maxLength': 50
        // 'order': 4
      },
      'brand': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '品牌',
        'language_key': 'efc_ocn_device_management__brand',
        'maxLength': 50
        // 'order': 5
      },
      'spec': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '规格',
        'language_key': 'efc_ocn_device_management__spec',
        'maxLength': 200
        // 'order': 6
      },
      'remarks': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '备注',
        'language_key': 'efc_ocn_device_management__remarks',
        'maxLength': 500
        // 'order': 13
      }
    },
    'table': 'efc_ocn_device_management'
  },
  // 设备管理编辑
  equipmentEdit: {
    '$schema': 'http://json-schema.org/draft-07/schema#',
    'type': 'object',
    'title': null,
    'required': [
      'deviceCommonId',
      'deviceName',
      'companyCode',
      'cylinderCode',
      'venueCode'
    ],
    'properties': {
      'deviceName': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备名称',
        'language_key': 'efc_ocn_device_management__device_name',
        'maxLength': 50
        // 'order': 4
      },
      'deviceCode': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备编号',
        'language_key': 'efc_ocn_device_management__device_code',
        'maxLength': 50
        // 'order': 3
      },
      'brand': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '品牌',
        'language_key': 'efc_ocn_device_management__brand',
        'maxLength': 50
        // 'order': 5
      },
      'spec': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '规格',
        'language_key': 'efc_ocn_device_management__spec',
        'maxLength': 200
        // 'order': 6
      },
      'remarks': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '备注',
        'language_key': 'efc_ocn_device_management__remarks',
        'maxLength': 500
        // 'order': 13
      }
    },
    'table': 'efc_ocn_device_management'
  },
  // 设备更换表单
  equipmentChange: {
    '$schema': 'http://json-schema.org/draft-07/schema#',
    'type': 'object',
    'title': null,
    'required': [
      'deviceCommonId',
      'deviceName',
      'companyCode',
      'cylinderCode',
      'venueCode',
      'recordDate'
    ],
    'properties': {
      'recordDate': {
        'view': 'date',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '业务日期',
        'defVal': '#{date}',
        'language_key': 'efc_ocn_device_change_record__record_date',
        'maxLength': 0,
        'order': 1
      },
      'deviceCommonId': {
        'view': 'sel_search',
        'dictCode': 'id',
        'dictTable': 'efc_ocn_device_common_name',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备类型',
        'language_key': 'efc_ocn_device_management__device_common_id',
        'dictText': 'name',
        'order': 2
      },
      'deviceCode': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备编号',
        'language_key': 'efc_ocn_device_management__device_code',
        'maxLength': 50,
        'order': 3
      },
      'deviceName': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '设备名称',
        'language_key': 'efc_ocn_device_management__device_name',
        'maxLength': 50,
        'order': 4
      },
      'brand': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '品牌',
        'language_key': 'efc_ocn_device_management__brand',
        'maxLength': 50,
        'order': 5
      },
      'spec': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '规格',
        'language_key': 'efc_ocn_device_management__spec',
        'maxLength': 200,
        'order': 6
      },
      'remarks': {
        'view': 'text',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '备注',
        'language_key': 'efc_ocn_device_management__remarks',
        'maxLength': 500,
        'order': 13
      }
    },
    'table': 'efc_ocn_device_management'
  },
  // 病案管理，结案弹框
  caseEnd: {
    '$schema': 'http://json-schema.org/draft-07/schema#',
    'type': 'object',
    'title': null,
    'required': [
      'end_date'
    ],
    'properties': {
      'end_date': {
        'view': 'date',
        'fieldExtendJson': '',
        'type': 'string',
        'title': '结案日期',
        'language_key': 'efc_ocn_medical_medical_record__end_date',
        'maxLength': 0,
        'order': 10
      }
    },
    'table': 'efc_ocn_medical_medical_record'
  }
}

// 设备管理详情
export const equipmentInfo = [
  {
    'view': 'text',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '设备名称',
    field: 'deviceName',
    'language_key': 'efc_ocn_device_management__device_name',
    'maxLength': 50,
    'order': 4
  },
  {
    'view': 'sel_search',
    'dictCode': 'id',
    'dictTable': 'efc_ocn_device_common_name',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '设备类型',
    field: 'deviceCommonId_dictText',
    'language_key': 'efc_ocn_device_management__device_common_id',
    'dictText': 'name',
    'order': 2
  },
  {
    'view': 'text',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '设备编号',
    field: 'deviceCode',
    'language_key': 'efc_ocn_device_management__device_code',
    'maxLength': 50,
    'order': 3
  },
  {
    'view': 'list',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '缸体',
    field: 'cylinderCode_dictText',
    'language_key': 'efc_ocn_device_management__cylinder_code',
    'maxLength': 32,
    'order': 11
  },
  {
    'view': 'link_down',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '公司',
    field: 'companyCode_dictText',
    'config': {
      'txt': 'depart_name',
      'idField': 'id',
      'condition': 'org_category=\'1\'',
      'linkField': 'aquariumCode',
      'pidField': 'parent_id',
      'table': 'sys_depart',
      'key': 'org_code'
    },
    'language_key': 'efc_ocn_device_management__company_code',
    'others': [
      {
        'title': '展区',
        'field': 'aquariumCode'
      }
    ],
    'order': 9
    // 'defVal': '#{sysOrgCode}'
  },
  {
    'view': 'list',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '海洋馆',
    field: 'venueCode_dictText',
    'language_key': 'efc_ocn_device_management__venue_code',
    'maxLength': 32,
    'order': 12
  },
  {
    'view': 'text',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '品牌',
    field: 'brand',
    'language_key': 'efc_ocn_device_management__brand',
    'maxLength': 50,
    'order': 5
  },
  {
    'view': 'text',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '规格',
    field: 'spec',
    'language_key': 'efc_ocn_device_management__spec',
    'maxLength': 200,
    'order': 6
  },
  {
    'view': 'text',
    'fieldExtendJson': '',
    'type': 'string',
    'title': '备注',
    field: 'remarks',
    'language_key': 'efc_ocn_device_management__remarks',
    'maxLength': 500,
    'order': 13
  }
]

export const prescriptionInfo = [
  {
    field: 'ingredientsName',
    'title': '成分名',
    'language_key': 'efc_ocn_medical_medical_record__record_code'
  },
  {
    field: 'goodsName',
    'title': '商品名',
    'language_key': 'efc_ocn_medical_medical_record__animal_id'
  },
  {
    field: 'specs',
    'title': '规格',
    'language_key': 'efc_ocn_medical_medical_record__record_date'
  },
  {
    field: 'dosage',
    'title': '用药剂量',
    'language_key': 'efc_ocn_medical_medical_record__disease_type'
  },
  {
    field: 'usageAmount',
    'title': '使用量',
    'language_key': 'efc_ocn_medical_medical_record__end_date'
  },
  {
    field: 'unit',
    'title': '单位',
    'language_key': 'efc_ocn_medical_medical_record__record_status'
  },
  {
    field: 'access_dictText',
    'title': '用药途径',
    'language_key': 'efc_ocn_medical_medical_record__record_code'
  },
  {
    field: 'times_dictText',
    'title': '用药次数',
    'language_key': 'efc_ocn_medical_medical_record__animal_id'
  },
  {
    field: 'startDate',
    'title': '起始日期',
    'language_key': 'efc_ocn_medical_medical_record__record_date'
  },
  {
    field: 'endDate',
    'title': '终止日期',
    'language_key': 'efc_ocn_medical_medical_record__disease_type'
  },
  {
    field: 'days',
    'title': '用药天数',
    'language_key': 'efc_ocn_medical_medical_record__end_date'
  }
]